import { ComponentType } from '@angular/cdk/portal';
import { Component, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { DiagnosisEventItem } from '../../models/diagnosis-event-item';
import { DiagnosisEventService } from '../../services/diagnosis-event/diagnosis-event.service';
import { UserSearchByPermissionComponent } from '../../components/field-components/user-search-by-permission/user-search-by-permission.component';
import { DiagnosisEventQuery } from '../../models/diagnosis-event-query';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { DecimalPipe } from '@angular/common';
import { finalize } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { OverlayLoadingDirective } from '../../directives/overlay-loading.directive';

export class AssignOpptyDialogModel {
  readonly component: ComponentType<any> = AssignOpptyDialogComponent;
  panelClass?: string | string[] = 'dialog-container';
  autoFocus?: boolean = false;
  data?: any;
  disableClose? = true;

  constructor(data: any) {
    this.data = data;
  }
}

@Component({
    selector: 'app-assign-oppty-dialog',
    templateUrl: './assign-oppty-dialog.component.html',
    styleUrls: ['./assign-oppty-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, OverlayLoadingDirective, MatRadioGroup, FormsModule, ReactiveFormsModule, MatRadioButton, UserSearchByPermissionComponent, MatDialogActions, MatButton, MatDialogClose, DecimalPipe]
})
export class AssignOpptyDialogComponent implements OnInit, OnDestroy {

  assignDialogForm: FormGroup;
  query: DiagnosisEventQuery;
  items: DiagnosisEventItem[] = [];
  parent: string;
  allEnabled = false;
  queryResultsCount = 0;

  loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading: Observable<boolean>;

  controlName = 'assign-user';
  modeControlName = 'assign-mode';

  modeControl = new FormControl('default', [Validators.required]);

  @ViewChild('assignSearchDialog') assignedComp: UserSearchByPermissionComponent;

  subs: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<AssignOpptyDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private opptyService: DiagnosisEventService,
    private fb: FormBuilder
  ) 
  {
    this.assignDialogForm = this.fb.group({});
    this.items = this.data.items;
    this.parent = this.data.parent;
    this.loading = this.loadingSubject.asObservable();
    this.allEnabled = this.data.allEnabled;
    this.queryResultsCount = this.data.queryResultsCount;
    this.query = this.data.query;

    if(this.allEnabled) {
      this.assignDialogForm.addControl(this.modeControlName, this.modeControl);
    }
  }

  ngOnInit(): void {
    //TODO
  }

  onAssignClick() {
    const value = this.assignedComp.getSingleModeValue();
    const query = this.modeControl?.value == 'default' ? undefined : this.query;
    const batchCount = query ? this.queryResultsCount : this.items.length;

    if(!value?.user) {
      return;
    }

    this.loadingSubject.next(true);

    this.subs.push(
      this.opptyService.updateAssignedOpptyListItems(this.items, value.user, batchCount, query)
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe(result => {
        this.dialogRef.close(result);
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
